import React, { Component } from 'react'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import AddCustomDocModalUI from './AddCustomDocModalUI.js'

class AddCustomDocModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: '',
      dueDate: null,
      isPromoterLevel: false,
      submitted: false,
      successMsg: null,
      errorList: []
    }
  }

  componentDidUpdate(prevProps) {
    // Reset form whenever modal is opened
    if (this.props.addMode && !prevProps.addMode) {
      this.setState({
        title: '',
        dueDate: null,
        isPromoterLevel: false,
        submitted: false,
        successMsg: null,
        errorList: []
      })
    }
  }

  render() {
    return (
      <AddCustomDocModalUI
        context={this.props.context}
        addMode={this.props.addMode}
        compliance={this.props.compliance}
        onCancelClick={this.props.onCancelClick}
        //
        title={this.state.title}
        onTitleChange={this.onTitleChange}
        dueDate={this.state.dueDate}
        onDueDateChange={this.onDueDateChange}
        isPromoterLevel={this.state.isPromoterLevel}
        onIsPromoterLevelChange={this.onIsPromoterLevelChange}
        //
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        onSubmitClick={this.onSubmitClick}
      />
    )
  }

  onTitleChange = (name, value) => {
    // InputTextUI may call onChange as:
    //   (event)        — raw DOM event
    //   (name, value)  — name/value pair
    //   (value)        — plain string
    let val
    if (value !== undefined) {
      // called as (name, value)
      val = value
    } else if (name && name.target !== undefined) {
      // called with a DOM event object
      val = name.target.value
    } else {
      // called with a plain string
      val = name
    }
    this.setState({ title: val || '', errorList: [] })
  }

  onDueDateChange = (name, value) => {
    const val = value !== undefined ? value : name
    this.setState({ dueDate: val, errorList: [] })
  }

  onIsPromoterLevelChange = (e) => {
    this.setState({ isPromoterLevel: e.target.checked })
  }

  onSubmitClick = () => {
    const { title, dueDate, isPromoterLevel } = this.state
    const { compliance } = this.props

    if (!title || typeof title !== 'string' || !title.trim()) {
      this.setState({ errorList: ['Document title is required'] })
      return
    }

    this.setState({ submitted: true, successMsg: null, errorList: [] })

    const body = {
      title: title.trim(),
      dueDate: dueDate || null,          // ISO string e.g. "2025-06-30", or null
      isPromoterLevel: isPromoterLevel,
      isMovable: true                    // always true for ad-hoc docs
    }

    // POST /api/su/loans/{loanId}/compliances/cp  OR  .../cs
    RestApiUtils.post(
      this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/compliances/${compliance}`,
      this.onSubmitClickCallback,
      body
    )
  }

  onSubmitClickCallback = (response) => {
    let errorList = []
    if (response.errorList && response.errorList.length) {
      response.errorList.forEach(error => errorList.push(error.message))
    }

    this.setState({
      submitted: false,
      successMsg: response.success ? 'Document added successfully' : null,
      errorList
    })

    if (errorList.length === 0) {
      // Refresh the compliance list so the new doc appears immediately
      setTimeout(() => {
        this.props.onRefreshClick('noBusy')
        this.props.onCancelClick()
      }, 800)
    }
  }
}

export default AddCustomDocModalSF